export default __webpack_public_path__ + "static/media/blogimg1.d2d33002.jpg";